
  import { mapState, mapGetters } from 'vuex'
  import cms from '~/mixins/common/cms'
  import playGames from '~/mixins/common/play-games'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    mixins: [cms, playGames, vipSettings],
    data() {
      return {
        drawer: false,
        rateDialog: false,
        maxLogoImageWidth: 0,
        isInitializedHeaderLogoDone: false
      }
    },
    computed: {
      ...mapState({
        vipTiers: state => state.activities['vip-system'].vipTiers,
        vipSystemLoading: state => state.activities['vip-system'].vipSystemLoading,
        vipTiersLoading: state => state.activities['vip-system'].vipTiersLoading,
        player: state => state.player.player,
        isLogin: state => state.settings.isLogin,
        globalFlag: state => state.settings.globalFlag,
        operationSetting: state => state.settings.operationSetting,
        isApp: state => state.app.isApp,
        missionSettings: state => state.activities['mission-reward'].missionsSettings,
        missionBadge: state => state.activities['mission-reward'].missionBadge,
        messageBadges: state => state.player.messageBadges
      }),
      globalFlagComputed() {
        return `fi fi-${this.globalFlag?.toLowerCase()}`
      },
      ...mapGetters({
        languages: 'themes/settings/language',
        headerLogo: 'cms/headerLogo',
        footerPartnerIcon: 'cms/footerPartnerIcon',
        footerArticle4: 'cms/footerArticle4',
        footerGamingInfo: 'cms/footerGamingInfo',
        detailArticles: 'cms/detailArticles',
        certificateImage: 'cms/certificateImage'
      }),
      infoItems() {
        return [
          {
            icon: 'mdi-account',
            text: this.tl('myProfile'),
            to: '/player/profile'
          },
          {
            icon: 'mdi-book',
            text: this.operationSettingCheckCrypto
              ? this.tl('walletAddress')
              : this.tl('bankDetail'),
            to: '/payment-methods'
          },
          {
            icon: 'mdi-message-text-fast-outline',
            text: this.tl('message'),
            actions: this.messageBadges,
            to: '/player/messages'
          },
          {
            icon: 'mdi-lock',
            text: this.tl('resetPassword'),
            to: '/reset-password'
          },
          {
            icon: 'mdi-play-circle',
            text: this.tl('myBonus'),
            to: '/my-bonus'
          },
          {
            icon: 'mdi-dots-horizontal-circle-outline',
            text: this.tl('moreInfo'),
            to: this.articleDefaultRoute
          }
        ]
      },
      menuItems() {
        const links = [
          {
            title: 'cashier',
            icon: '/theme-2/drawer/cashier.png',
            route: '/cashier',
            status: true
          },
          {
            title: 'history',
            icon: '/theme-2/drawer/history.png',
            route: '/history/transaction',
            status: true
          },
          {
            title: 'promotion',
            icon: '/theme-2/drawer/promotion.png',
            route: '/promotion',
            status: true
          },
          {
            title: 'activities',
            icon: '/theme-2/drawer/activities.png',
            route: '/activities',
            status: this.missionStatusInfo.mission_status
          }
        ]

        return links.filter(item => item.status)
      },
      articleDefaultRoute() {
        if (this.detailArticles?.[0]?.title && this.detailArticles?.[0]?.items?.[0]?.title) {
          const title = this.detailArticles?.[0].title[`${this.$cookie.get('wl_locale')}-slug`]
          const slug =
            this.detailArticles?.[0]?.items?.[0]?.title[`${this.$cookie.get('wl_locale')}-slug`]
          const mainId = this.detailArticles?.[0]?._id
          const subId = this.detailArticles?.[0]?.items?.[0]?._id
          const component = this.detailArticles?.[0]?.component_code
          return `/articles/${title}/${slug}?main_id=${mainId}&sub_id=${subId}&component_code=${component}`
        }
        return '/articles'
      }
    },
    mounted() {
      // this.initializeLogoWidth()
      // Call this store action only when the user is not on the home page but on mobile device
      if (this.isMobileOnly()) this.$store.dispatch('cms/footerCMS', { platform: 2 })
      // Call this store action only when the user is not on the home page
      if (this.$route.path !== '/')
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'HeaderLogo'
        })
      if (this.$cookie.get('token')) {
        if (this.player.player_id) return
        this.$store.dispatch('player/profile')
        this.$store.dispatch('settings/toggleIsLogin', true)
        this.$store.dispatch('player/totalBalance')
      }
    },
    beforeDestroy() {
      this.doCancelAxiosRequest()
    },
    methods: {
      getCurrentLocale(localeCode) {
        const currentLocaleData = this.languages.filter(el => el.code === localeCode)
        if (currentLocaleData.length > 0) {
          return currentLocaleData[0]?.flag_icon
        }
        return null
      },
      openExchangeRateDialog() {
        this.rateDialog = true
        setTimeout(() => {
          const idExchange = document.getElementById('idExchangeRate')
          idExchange.classList.remove('v-list-item--active')
        }, 1000)
      },
      initializeLogoWidth() {
        if (this.isInitializedHeaderLogoDone) return
        const _this = this
        setTimeout(() => {
          const headerEl = document.getElementById('mobile-header-el')
          const loginBtnEl = document.getElementById('login-btn-el')
          const burgerIconEl = document.getElementById('menu-bar-id')
          const headerElPadding = 24

          if (headerEl) {
            const maxAllowedImageWidth =
              headerEl.offsetWidth -
              (loginBtnEl.offsetWidth + burgerIconEl.offsetWidth + headerElPadding)

            this.maxLogoImageWidth = maxAllowedImageWidth
          }
        }, 500)

        setTimeout(() => {
          document.querySelectorAll('.header-logo-container img').forEach(img => {
            _this.isInitializedHeaderLogoDone = true
            if (img.naturalWidth > img.parentElement.clientWidth) {
              img.style.width = '90%'
              img.style.maxWidth = '200px'
              img.style.height = 'auto'
              img.style.maxHeight = '40px'
              img.style.opacity = 1
            } else {
              img.style.opacity = 1
            }
          })
          _this.initializeLogoWidth()
        }, 500)
      }
    }
  }
